import api from '@/api';

export const actions = {

    societyDashUpdateUser({dispatch, commit}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'societies/' + data.id, data:data, method: 'PUT'})
                .then(resp => {
                    commit('authStoreCurrentUser', resp.data);
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyDashAvailableMatches({dispatch}) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'matches/availables', method: 'GET'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },

    societyDashGetNotices({dispatch}) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');
            api({url: 'notices/society', method: 'GET'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        });
    },


}